// extracted by mini-css-extract-plugin
export var blue = "_p-f";
export var brand = "_p-b";
export var darkGrey = "_p-e";
export var disabled = "_p-4";
export var disabledSubtle = "_p-5";
export var error = "_p-6";
export var green = "_p-g";
export var grey = "_p-d";
export var icon = "_p-0";
export var inherit = "_p-a";
export var lightGrey = "_p-c";
export var orange = "_p-i";
export var pink = "_p-k";
export var primary = "_p-1";
export var purple = "_p-l";
export var red = "_p-j";
export var secondary = "_p-2";
export var success = "_p-9";
export var tertiary = "_p-3";
export var warning = "_p-7";
export var warningSecondary = "_p-8";
export var white = "_p-m";
export var yellow = "_p-h";